import React from 'react'
import { useSelector } from 'react-redux';

//Dependencies.
import { Alert, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { videosReducer } from '../../../slices/allVideosSlice';

//Components.
import AddVideoForm from '../../form/add-video-form/AddVideoForm'


const NewVideoModal = ({ modal, setModal }) => {
   const videosReducer_isLoading = useSelector(videosReducer).isLoading;
   const videosReducer_message = useSelector(videosReducer).message;
   console.log({ videosReducer_isLoading, videosReducer_message });

   const toggle = () => setModal(!modal);

   const closeBtn = (
      <button className='close' onClick={toggle} type='button' style={{border: "none"}}>
         <strong className='text-danger' style={{fontWeight: 'bolder'}}>&times;</strong>
      </button>
   )   

   return (
      <Modal isOpen={modal} toggle={toggle} fullscreen>
         { videosReducer_isLoading && <Alert color='danger'><h1>{ videosReducer_message }</h1></Alert> }
         <ModalHeader close={closeBtn}>
            <strong>ADD NEW VIDEO.</strong>
         </ModalHeader>

         <ModalBody style={{display: 'flex', justifyContent: 'center'}}>
            <AddVideoForm toggle={toggle} />
         </ModalBody>
      </Modal>
   )
}

export default NewVideoModal